import { Button, Form, FormProps, Input } from 'antd';

import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

type FieldType = {
	name: string;
	email: string;
	contact: string;
};

function ProfileDataEditComponent() {
	const [isLoading, setIsLoading] = useState(false);
	const [dataForm] = Form.useForm();

	const navigate = useNavigate();

	const onFinish: FormProps<FieldType>['onFinish'] = (values) => {
		console.log('Success:', values);
	};

	const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
		console.log('Failed:', errorInfo);
	};

	const onSubmit = () => {
		dataForm.submit();
		setIsLoading(true);
		setTimeout(() => {
			navigate('/profile/data');
		}, 1000);
	};

	const onDiscard = () => {
		navigate('/profile/data');
	};

	return (
		<>
			<div className="sectionContainer titled">
				<header>Profile Details</header>
				<main>
					<Form form={dataForm} name="basic" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off">
						<Form.Item<FieldType> label="Full name" labelAlign="left" name="name" rules={[{ required: true, message: 'Please input your full name!' }]}>
							<Input size="large" />
						</Form.Item>

						<Form.Item<FieldType> label="Email" labelAlign="left" name="email" rules={[{ required: true, message: 'Please input your email!' }]}>
							<Input type="email" size="large" />
						</Form.Item>

						<Form.Item<FieldType> label="Phone number" labelAlign="left" name="contact" rules={[{ required: true, message: 'Please input your phone number!' }]}>
							<Input type="number" size="large" />
						</Form.Item>
					</Form>
				</main>

				<footer className="d-flex justify-content-end gap-2">
					<Button className="discard" onClick={onDiscard}>
						Discard
					</Button>

					<Button type="primary" onClick={onSubmit} loading={isLoading}>
						Save changes
					</Button>
				</footer>
			</div>
		</>
	);
}

export default ProfileDataEditComponent;
